<script lang="ts">
    import Button from "@components/button/Button.svelte"
    import PopupBanner from "@components/popup/PopupBanner.svelte"
    import PopupButtons from "@components/popup/PopupButtons.svelte"
    import PopupExit from "@components/popup/PopupExit.svelte"
    import PopupHeading from "@components/popup/PopupHeading.svelte"
    import PopupIcon from "@components/popup/PopupIcon.svelte"
    import PopupIconDivider from "@components/popup/PopupIconDivider.svelte"
    import PopupParagraph from "@components/popup/PopupParagraph.svelte"

    export let exit: () => void
    export let gotoReminders: () => void
</script>

<PopupBanner>
    <PopupIconDivider>
        <div slot="icon">
            <PopupIcon class="text-2xl dark:text-black bg-blue-100" icon="sunset" />
        </div>
        <PopupHeading>Your reminder window has not started yet</PopupHeading>
    </PopupIconDivider>
</PopupBanner>
<PopupParagraph>
    Wait until your practice day begins, or adjust your wake-up time to start reminders now.
</PopupParagraph>
<PopupButtons>
    <Button
        go={async () => {
            gotoReminders()
        }}
        color="gold"
    >
        Change time
    </Button>
    <Button
        go={() => {
            exit()
        }}
        color="white"
    >
        Close
    </Button>
</PopupButtons>
